import gql from 'graphql-tag';

const query = gql`
  {
    hotelFilterList {
      chain_code
      chain_name
      hotel_filter_name
    }
  }
`;

export default function fetchHotelBrands({ apollo }) {
  return apollo.query({
    query,
    variables: {}
  });
}
